import { InstallmentsContainer } from './InstallmentsContainer';
import { InstallmentsTable } from './InstallmentsTable';

export const Installments = ({ installments }) => {
  if (!installments) {
    return null;
  }

  if (installments.length === 0) {
    return (
      <InstallmentsContainer>
        <p className="text-secondary fs-5">
          Seus boletos serão gerados automaticamente após o upload do XML da NFe
        </p>
      </InstallmentsContainer>
    );
  }

  return (
    <InstallmentsContainer installmentsQuantity={installments.length}>
      <div className="row mt-3">
        <InstallmentsTable installments={installments} />
      </div>
    </InstallmentsContainer>
  );
};
